import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

const viewport = {
  content: "width=device-width, initial-scale=1.0, user-scalable=no",
};

const router = new Router({
  routes: [
    {
      path: "/",
      redirect: "/workbench",
    },
    {
      path: "/workbench",
      name: "Workbench",
      component: () => import("@/views/workbench/index.vue"),
      meta: { title: "工作台", viewport: viewport },
    },
    {
      path: "/login",
      name: "Login",
      component: () => import("@/views/login/index.vue"),
      meta: { title: "YLab-Cloud", viewport: viewport },
    },
    {
      path: "/admin/design",
      name: "Design",
      component: () => import("@/views/admin/FormProcessDesign.vue"),
      meta: { title: "表单流程设计", viewport: viewport },
      redirect: "/admin/design/formSetting",
      children: [
        {
          path: "formSetting",
          name: "FormSetting",
          component: () => import("@/views/admin/layout/FormDesign.vue"),
          meta: { title: "表单设计" },
        },
        {
          path: "processDesign",
          name: "ProcessDesign",
          component: () => import("@/views/admin/layout/ProcessDesign.vue"),
          meta: { title: "流程设计" },
        },
        {
          path: "tableDesign",
          name: "TableDesign",
          component: () => import("@/views/admin/layout/TableDesign.vue"),
          meta: { title: "列表设计" },
        },
        {
          path: "formProSetting",
          name: "FormProSetting",
          component: () => import("@/views/admin/layout/FormProSetting.vue"),
          meta: { title: "高级设置" },
        },
        {
          path: "backCode",
          name: "BackCode",
          component: () => import("@/views/admin/layout/BackCode.vue"),
          meta: { title: "后端代码" },
        },
        {
          path: "frontCode",
          name: "FrontCode",
          component: () => import("@/views/admin/layout/FrontCode.vue"),
          meta: { title: "前端代码" },
        },
      ],
    },
    {
      path: "/design",
      name: "FormDesign",
      component: () => import("@/views/design/index.vue"),
      meta: { title: "仪表盘", viewport: viewport },
    },
    {
      path: "/home",
      name: "Home",
      component: () => import("@/views/home/index.vue"),
      meta: { title: "首页", viewport: viewport },
    },
    {
      path: "/detail",
      name: "Detail",
      component: () => import("@/views/detail/index.vue"),
      meta: { title: "详情", viewport: viewport },
    },
    {
      path: "/backlog",
      name: "Backlog",
      component: () => import("@/views/backlog/index.vue"),
      meta: { title: "待办", viewport: viewport },
    },
    {
      path: "/error_msg",
      name: "ErrorMsg",
      component: () => import("@/views/errorMsg/index.vue"),
      meta: { title: "报错信息", viewport: viewport },
    },
    {
      path: "/site",
      name: "Site",
      redirect: "/site/home",
      component: () => import("@/views/site/layout/index.vue"),
      children: [
        {
          path: "home",
          name: "SiteHome",
          component: () => import("@/views/site/Home.vue"),
          meta: { title: "首页" },
        },
        {
          path: "template",
          name: "SiteTemplate",
          component: () => import("@/views/site/Template.vue"),
          meta: { title: "模板中心" },
        },
        {
          path: "product",
          name: "SiteProduct",
          component: () => import("@/views/site/Product.vue"),
          meta: { title: "产品介绍" },
        },
        {
          path: "scheme",
          name: "SiteScheme",
          component: () => import("@/views/site/Scheme.vue"),
          meta: { title: "解决方案" },
        },
      ],
    },
    {
      path: "/cmsAdmin",
      name: "CmsAdmin",
      redirect: "/cmsAdmin/user",
      component: () => import("@/views/cmsAdmin/layout/index.vue"),
      children: [
        {
          path: "user",
          name: "cmsAdminUser",
          component: () => import("@/views/cmsAdmin/user.vue"),
          meta: { title: "用户管理" },
        },
        {
          path: "role",
          name: "cmsAdminRole",
          component: () => import("@/views/cmsAdmin/role.vue"),
          meta: { title: "角色权限管理" },
        },
        {
          path: "dataLog",
          name: "DataLog",
          component: () => import("@/views/cmsAdmin/dataLog.vue"),
          meta: { title: "数据日志" },
        },
        {
          path: "moduleLog",
          name: "ModuleLog",
          component: () => import("@/views/cmsAdmin/moduleLog.vue"),
          meta: { title: "应用日志" },
        },
        {
          path: "loginLog",
          name: "LoginLog",
          component: () => import("@/views/cmsAdmin/loginLog.vue"),
          meta: { title: "登录日志" },
        },
        {
          path: "template",
          name: "Template",
          component: () => import("@/views/cmsAdmin/template.vue"),
          meta: { title: "模板配置" },
        },
        {
          path: "solution",
          name: "Solution",
          component: () => import("@/views/cmsAdmin/solution.vue"),
          meta: { title: "解决方案配置" },
        },
      ],
    },
  ],
});

export default router;
